import type { ExtensionRecord, RawEditor, SharedExtensionsRecord } from '../editor.types';

type ComposeSharedExtensionFn = (editors: RawEditor[], extensions: ExtensionRecord) => SharedExtensionsRecord;

export const composeSharedExtensions: ComposeSharedExtensionFn = (editors, extensions) =>
    editors.reduce((acc, editor) => {
        if ('x-in-shared-folder' in editor) {
            const editExtension = Object.keys(extensions).reduce((acc, ext) => ({ ...acc, [ext]: true }), {});

            return { ...acc, ...editExtension };
        }

        return acc;
    }, {} as SharedExtensionsRecord);
